export default __webpack_public_path__ + "static/media/landingBackground5Mobile.daa4b070.png";